/* product-reviews.js — قسم «ماذا يقول القرّاء» (2026-10-30)
   - «عرض تقييمات أكثر»: يجيب الصفحات التالية من Judge.me (نفس البيانات اللي يقراها تطبيقهم بالمتجر)
   - «اكتب تقييمك»: نموذج داخل المتجر يرسل التقييم لـJudge.me، ويظهر بعد موافقة صاحب المتجر
   نص التقييمات يدخل كنص (textContent) مو كـHTML، عشان ما ينحقن أي كود. */
(() => {
  if (customElements.get('asoule-reviews')) return;

  const MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  const LIST_API = 'https://api.judge.me/reviews/reviews_for_widget';
  const SEND_API = 'https://judge.me/api/v1/reviews';

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const svg = (markup) => {
    const t = document.createElement('template');
    t.innerHTML = markup.trim();
    return t.content.firstChild;
  };
  const CHECK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12 5 5 9-10"/></svg>';

  class AsouleReviews extends HTMLElement {
    connectedCallback() {
      this.shop = this.dataset.shop;
      this.productId = this.dataset.productId;
      this.shopName = this.dataset.shopName || '';
      this.perPage = parseInt(this.dataset.perPage, 10) || 5;
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.arabicNum = this.dataset.num === 'arabic';
      this.list = this.querySelector('[data-list]');
      this.moreBtn = this.querySelector('[data-more]');
      this.note = this.querySelector('[data-note]');
      this.dialog = this.querySelector('dialog.prv-form');

      if (this.moreBtn) this.moreBtn.addEventListener('click', () => this.loadMore());
      this.querySelectorAll('[data-open-form]').forEach((b) => b.addEventListener('click', () => this.openForm()));
      if (this.dialog) this.setupForm();
      if (location.hash === '#write-review') this.openForm();
    }

    num(v) {
      const s = String(v);
      return this.arabicNum ? s.replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d]) : s;
    }

    fmtDate(iso) {
      const d = new Date(iso);
      if (isNaN(d)) return '';
      return `${this.num(d.getUTCDate())} ${MONTHS[d.getUTCMonth()]} ${this.num(d.getUTCFullYear())}`;
    }

    async loadMore() {
      const btn = this.moreBtn;
      const page = (parseInt(btn.dataset.page, 10) || 1) + 1;
      const label = btn.querySelector('[data-more-label]');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      label.textContent = 'لحظة…';
      try {
        const url = `${LIST_API}?url=${encodeURIComponent(this.shop)}&shop_domain=${encodeURIComponent(this.shop)}&platform=shopify&per_page=${this.perPage}&page=${page}&product_id=${encodeURIComponent(this.productId)}`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const reviews = (data.reviews || []).filter((r) => (r.reviewer_name || '') !== this.shopName);
        reviews.forEach((r) => this.list.appendChild(this.renderReview(r)));
        btn.dataset.page = page;
        const totalPages = (data.pagination && data.pagination.total_pages) || Math.ceil(this.total / this.perPage);
        if (page >= totalPages || !(data.reviews || []).length) {
          btn.remove();
          this.moreBtn = null;
        } else {
          label.textContent = 'عرض تقييمات أكثر';
          btn.disabled = false;
        }
        this.say(`انضافت ${this.num(reviews.length)} تقييمات`);
      } catch (e) {
        label.textContent = 'جرّب مرة ثانية';
        btn.disabled = false;
        this.say('ما قدرنا نجيب التقييمات الحين، جرّب بعد شوي.');
      } finally {
        btn && btn.removeAttribute('aria-busy');
      }
    }

    say(text) {
      if (!this.note) return;
      this.note.textContent = text;
      this.note.hidden = false;
      clearTimeout(this._t);
      this._t = setTimeout(() => { this.note.hidden = true; }, 4000);
    }

    renderReview(r) {
      const li = el('li', 'prv-item');
      const head = el('div', 'prv-item__head');
      head.appendChild(el('span', 'prv-item__avatar', r.reviewer_initial || '؟')).setAttribute('aria-hidden', 'true');
      const who = el('div', 'prv-item__who');
      who.appendChild(el('span', 'prv-item__name', r.reviewer_name || ''));
      if (r.verified_buyer) {
        const v = el('span', 'prv-item__verified');
        v.appendChild(svg(CHECK));
        v.appendChild(document.createTextNode('مشتري موثّق'));
        who.appendChild(v);
      }
      head.appendChild(who);
      li.appendChild(head);

      const meta = el('div', 'prv-item__meta');
      const stars = el('span', 'prv-stars');
      const rating = Number(r.rating) || 0;
      stars.style.setProperty('--pct', `${rating * 20}%`);
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${rating} من ٥`);
      meta.appendChild(stars);
      const time = el('time', null, this.fmtDate(r.created_at));
      time.dateTime = r.created_at || '';
      meta.appendChild(time);
      li.appendChild(meta);

      if (r.title) li.appendChild(el('p', 'prv-item__title', r.title));
      const body = (r.body || '').trim();
      if (body) li.appendChild(el('p', 'prv-item__body', body));

      const pics = r.pictures_urls || [];
      if (pics.length) {
        const wrap = el('div', 'prv-item__pics');
        pics.forEach((p) => {
          const full = (p && (p.original || p.huge)) || p;
          const thumb = (p && (p.compact || p.small)) || full;
          if (typeof full !== 'string' || !/^https:\/\//.test(full)) return;
          const a = el('a', 'prv-item__pic');
          a.href = full;
          a.target = '_blank';
          a.rel = 'noopener nofollow';
          const img = el('img');
          img.src = thumb;
          img.alt = `صورة من تقييم ${r.reviewer_name || ''}`;
          img.loading = 'lazy';
          img.width = 88;
          img.height = 88;
          a.appendChild(img);
          wrap.appendChild(a);
        });
        if (wrap.children.length) li.appendChild(wrap);
      }

      if (r.reply_content) {
        const tmp = document.createElement('div');
        tmp.innerHTML = String(r.reply_content); // نستخرج النص فقط
        const reply = el('div', 'prv-item__reply');
        reply.appendChild(el('span', 'prv-item__reply-by', `ردّ ${this.shopName}`));
        reply.appendChild(el('p', null, (tmp.textContent || '').trim()));
        li.appendChild(reply);
      }
      return li;
    }

    /* ---------- النموذج ---------- */
    openForm() {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('prv-lock');
    }

    closeForm() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
    }

    setupForm() {
      const dlg = this.dialog;
      this.form = dlg.querySelector('[data-form]');
      this.done = dlg.querySelector('[data-done]');
      this.err = dlg.querySelector('[data-error]');
      this.sendBtn = dlg.querySelector('[data-send]');

      dlg.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.closeForm()));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) this.closeForm(); });
      dlg.addEventListener('close', () => {
        document.documentElement.classList.remove('prv-lock');
        if (!this.done.hidden) {
          this.form.reset();
          this.form.hidden = false;
          this.done.hidden = true;
        }
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.send();
      });
    }

    showError(text, field) {
      this.err.textContent = text;
      this.err.hidden = false;
      if (field) field.focus();
    }

    async send() {
      const f = this.form;
      const data = new FormData(f);
      const rating = Number(data.get('rating'));
      const body = String(data.get('body') || '').trim();
      const name = String(data.get('name') || '').trim();
      const email = String(data.get('email') || '').trim();
      this.err.hidden = true;

      if (!rating) return this.showError('اختر عدد النجوم.', f.querySelector('input[name="rating"]'));
      if (body.length < 3) return this.showError('اكتب رأيك بالكتاب.', f.elements.body);
      if (!name) return this.showError('اكتب اسمك.', f.elements.name);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.showError('اكتب إيميل صحيح.', f.elements.email);

      // حقل مخفي: البرامج اللي تعبّي كل الحقول تتعبّيه، والناس ما يشوفونه
      if (String(data.get('website') || '').trim()) return this.finish();

      const params = new URLSearchParams({
        shop_domain: this.shop,
        platform: 'shopify',
        id: this.productId,
        name,
        email,
        rating: String(rating),
        body,
      });

      this.sendBtn.disabled = true;
      this.sendBtn.setAttribute('aria-busy', 'true');
      const oldLabel = this.sendBtn.textContent;
      this.sendBtn.textContent = 'قاعد نرسل…';
      try {
        const res = await fetch(SEND_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: params.toString(),
        });
        if (!res.ok) throw new Error(res.status);
        this.finish();
      } catch (e) {
        this.showError('ما وصل التقييم، جرّب مرة ثانية بعد شوي.');
      } finally {
        this.sendBtn.disabled = false;
        this.sendBtn.removeAttribute('aria-busy');
        this.sendBtn.textContent = oldLabel;
      }
    }

    finish() {
      this.form.hidden = true;
      this.done.hidden = false;
      const ok = this.done.querySelector('[data-close]');
      if (ok) ok.focus();
    }
  }

  customElements.define('asoule-reviews', AsouleReviews);
})();
